import React, {useState, useEffect} from 'react'
import {Helmet, HelmetProvider} from 'react-helmet-async'
import {format} from 'date-fns';
import {confirmAlert} from 'react-confirm-alert'
import {useForm} from 'react-hook-form'
import useEventsHook from '../../../api/events'
// import {ErrorBoundary} from "react-error-boundary";
// import {useNavigate} from 'react-router-dom';
import {ViewEvents} from '../../../components/admin/events/ViewEvents';
import {FormEvents} from '../../../components/admin/events/FormEvents';
import {
    Spinner,
    Pagination,
    Message,
    Confirm, Search,
} from '../../../components'
// import {Button} from "@mui/material";

const Events = () => {
    const [page, setPage] = useState(1)
    const [id, setId] = useState(null)
    const [edit, setEdit] = useState(false)
    const [q, setQ] = useState('')

    const {getEvents, postEvent, updateEvent, deleteEvent} = useEventsHook({
        page,
        q,
    })

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: {errors},
    } = useForm({
        defaultValues: {
            confirmed: true,
            blocked: false,
        },
    })

    const {
        data,
        isLoading,
        isError,
        error,
        refetch
    } = getEvents

    const {
        isLoading: isLoadingUpdate,
        isSuccess: isSuccessUpdate,
        mutateAsync: mutateAsyncUpdate,
    } = updateEvent

    const {
        isLoading: isLoadingDelete,
        mutateAsync: mutateAsyncDelete,
    } = deleteEvent

    const {
        isLoading: isLoadingPost,
        isSuccess: isSuccessPost,
        mutateAsync: mutateAsyncPost,
    } = postEvent

    const formCleanHandler = () => {
        setEdit(false);
        reset();  // Reset form via react-hook-form
    };

    useEffect(() => {
        if (isSuccessPost || isSuccessUpdate) {
            setEdit(false);
        }
    }, [isSuccessPost, isSuccessUpdate])

    useEffect(() => {
        if (q.trim() || page) {
            refetch();
        }
    }, [page, q, refetch]);

    const searchHandler = (e) => {
        e.preventDefault()
        refetch()
        setPage(1)
    }

    const deleteHandler = (id) => {
        confirmAlert(Confirm(() => mutateAsyncDelete(id)))
    }

    const submitHandler = async (data) => {
        try {
            // console.log(edit);
            if (edit) {
                await mutateAsyncUpdate({
                    _id: id,
                    title: data.title,
                    address: data.address,
                    description: data.description,
                    glocation: data.glocation,
                    link: data.link,
                    // date: data.date,
                    dateStart: data.dateStart,
                    dateEnd: data.dateEnd,
                    time: data.time,
                    image: data.image,
                    category: data.category,
                    tags: data.tags,
                    email: data.email,
                    confirmed: data.confirmed,
                    blocked: data.blocked
                });
            } else {
                await mutateAsyncPost(data);
            }

            // Request succeeded
            if (edit) {
                console.log('SUCCESSFULL EDIT POST');
            } else {
                console.log('SUCCESSFULL NEW POST');
            }
        } catch (error) {
            // Request failed
            console.error(error);
            if (edit) {
                console.log('FAILED EDIT POST')

            } else {
                console.log('FAILED NEW POST')
            }
            if (error.response && error.response.status === 500) {
                console.log('FAILED POST 500')
            }
        }
    };

    const editHandler = (event) => {


        // console.log(event)
        const dateStart = Date.parse(event.dateStart);
        const formattedDateStart = isNaN(dateStart) ? null : format(new Date(dateStart), 'yyyy-MM-dd');

        const dateEnd = Date.parse(event.dateEnd);
        const formattedDateEnd = isNaN(dateEnd) ? null : format(new Date(dateEnd), 'yyyy-MM-dd');

        // console.log(formattedDateStart)
        // console.log(formattedDateEnd)

        setId(event._id)
        setEdit(true)
        setValue('title', event.title)
        setValue('address', event.address)
        setValue('description', event.description)
        setValue('glocation', event.glocation)
        setValue('link', event.link)
        // setValue('date', event.date)
        setValue('dateStart', formattedDateStart)
        setValue('dateEnd', formattedDateEnd)
        setValue('time', event.time)
        setValue('image', event.image)
        setValue('category', event.category)
        setValue('tags', event.tags)
        setValue('email', event.email)
        setValue('confirmed', event.confirmed)
        setValue('blocked', event.blocked)
    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Events</title>
                    <meta property='og:title' content='Events' key='title'/>
                </Helmet>
            </HelmetProvider>
            <div className='view-list-top-bar'>

                <h3 className='fw-light text-muted text-center mb-3'>
                    Events List{' '}
                    <sup className='fs-6'> [{data && data.total}] </sup>
                </h3>

                <div className='d-flex align-items-center justify-content-between mb-2'>
                    <button
                        className='btn add-new-entry-button align-self-end'
                        data-bs-toggle='modal'
                        data-bs-target='#eventModal'
                        onClick={() => formCleanHandler(true)}
                    >
                        Add New Event
                    </button>
                    <Pagination data={data} setPage={setPage}/>
                </div>

                <div className='col-auto full-search'>
                    <Search
                        placeholder='Search by Title'
                        setQ={setQ}
                        q={q}
                        searchHandler={searchHandler}
                    />
                </div>
            </div>


            {isLoading ? (
                <Spinner/>
            ) : isError ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <ViewEvents
                    data={data}
                    editHandler={editHandler}
                    deleteHandler={deleteHandler}
                    isLoadingDelete={isLoadingDelete}
                />
            )}
            <div className='pagination-bottom-block'>
                <Pagination data={data} setPage={setPage}/>
            </div>
            <FormEvents
                edit={edit}
                formCleanHandler={formCleanHandler}
                isLoading={isLoading}
                setValue={setValue}
                isError={isError}
                errors={errors}
                isLoadingUpdate={isLoadingUpdate}
                isLoadingPost={isLoadingPost}
                register={register}
                handleSubmit={handleSubmit}
                submitHandler={submitHandler}
                watch={watch}
                error={error}
            />
        </>
    )
}

export default Events
